<script setup lang="ts">
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useTheme } from 'vuetify'
import ScrollToTop from '@core/components/ScrollToTop.vue'
import initCore from '@core/initCore'
import { initConfigStore, useConfigStore } from '@core/stores/config'
import { hexToRgb } from '@core/utils/colorConverter'

const { error } = useSnackbar()

// theme + store setup
const { global } = useTheme()
initCore()
initConfigStore()
const configStore = useConfigStore()

// 🧩 Global error handler
onMounted(() => {
  const app = getCurrentInstance()?.appContext.app
  if (!app) return

  app.config.errorHandler = (err, instance, info) => {
    console.error('Global Vue error:', err, info)
    error('⚠️ Something went wrong. Please try again later.')
  }

  // Also handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    console.error('Unhandled Promise rejection:', e.reason)
    error('⚠️ Unexpected error occurred.')
  })
})
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <!-- 🔥 Global Error Snackbar -->
      <GlobalSnackbar />

      <RouterView />
      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
